export default __webpack_public_path__ + "static/media/Icons_Instagram_copia.21abcdcf.svg";